<template>
  <div class="">


    <div class="col-12">
      <b-row>

        <div class="col-6">
          <h4>ساخت رویداد</h4>
        </div>

        <div class="col-6 text-left">
          <router-link :to="{ name: 'EventCreate' }" class="ml-2 mt-1">
            <b-button pill variant="purple">ساخت رویداد</b-button>
          </router-link>
        </div>


      </b-row>
    </div>


    <table class="table table-hover table-striped table-bordered table-responsive-md table-responsive-sm">
      <thead>
      <tr>
        <th>شناسه</th>
        <th>نام</th>
        <th>#</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="event in events">
        <th>{{ event.id }}</th>
        <td>{{ event.name }}</td>
        <td>


          <router-link target="_blank" class="h5"
                       :to="{ name: 'EventUpdate', params: { id: event.id } }">
            <b-icon icon="pencil" class="h5 mr-3"></b-icon>
          </router-link>

          <b-icon icon="trash" @click="deleteEvent(event)" class="h5 mr-3"></b-icon>
        </td>
      </tr>
      </tbody>
    </table>

    <b-row class="pt-3 mt-3 justify-content-center">
      <pagination :meta="pagination" :on-change-page="changePage"/>
    </b-row>


  </div>
</template>


<script>
import Pagination from "../../components/dashboard/Pagination.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import LanguageSelectBox from "../../components/dashboard/Language/LanguageSelectBox.vue";

export default {
  name: "Event",
  components: {LanguageSelectBox, Pagination},
  data() {
    return {
      events: [],
      pagination: {},
    }
  },
  methods: {
    async loadEvents() {
      let req = await this.$store.dispatch('Event/getEvents')
      let data = req.data.data
      this.events = data.data
      this.pagination = data.meta
    },
    deleteEvent(event) {
      this.$store.dispatch('Event/deleteEvent', event).then(res => {
        this.loadEvents()
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
      })
    },
    changePage(page) {
      console.log('in', page)
    }
  },
  async mounted() {
    await this.loadEvents()
  }

}
</script>

<style scoped>

</style>